import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import QueryStringUtility from './QueryStringUtility';
import Registration from '@/Registration';
import RecaptchaProtectedResponse from './RecaptchaProtectedResponse';

export class RegistrationServiceStatic {
    confirmAccount(code: string): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/confirmaccount${QueryStringUtility.getQueryString({code})}`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({ })));
    }

    register(model: Registration): Promise<AxiosResponse<RecaptchaProtectedResponse>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/register`
        return AxiosPostProcessor.postProcess(Axios.post<RecaptchaProtectedResponse>(url, model, AxiosDefaultRequestConfig.merge({ })));
    }
}
const RegistrationService = new RegistrationServiceStatic();
export default RegistrationService;
